module.exports = __webpack_public_path__ + "img/43_43.d6049907.png";